module.exports = __webpack_public_path__ + "static/zapier-switchboard-1-eac414b03b86b1c484bcee4d68e7127f.svg";